export { TabbedHeader } from './tabbed-header';
export type { TabbedHeaderProps, TabbedHeaderLinkProps, TabItem } from './types';
